import { render, staticRenderFns } from "./PopupDocumentsSignature.vue?vue&type=template&id=35b2dbe6"
import script from "./PopupDocumentsSignature.vue?vue&type=script&lang=ts"
export * from "./PopupDocumentsSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports